import { axios } from '..';
import { ILeadershipEntry } from '../interfaces/models/ILeadershipEntry';

/** WSG Leadership of a profile: BoD / Regional Council appointments plus WSG groups. */
export const getPersonLeadership = async (personId: string): Promise<ILeadershipEntry[]> => {
  try {
    const params = new URLSearchParams({ personId });
    const response = await axios.Get(`/personLeadership?${params.toString()}`);
    return response?.data ?? [];
  } catch (error) {
    console.error('Error fetching person leadership:', error);
    return [];
  }
};
